import * as d3 from 'd3'

const margin = { top: 50, right: 70, bottom: 50, left: 70 }
const legenditemHeight = 28
const legendWidth = 500
const height = 400 - margin.bottom - margin.top
const width = () => parentWidth() - margin.left - margin.right

const fetchHeaderHeight = stackedKeysLength => {
  return legenditemHeight * (stackedKeysLength + 1) + margin.top
}

const setUpChart = (containerSelector, stackedKeysLength) => {
  let headerHeight = fetchHeaderHeight(stackedKeysLength)

  // Svg container
  const svg = selectSvg(containerSelector)
  svg.html('') // reset any existing innerHTML
  svg
    .attr('width', width() + margin.left + margin.right)
    .attr('height', height + margin.bottom + margin.top + headerHeight)

  // Header
  let header = svg.append('g').attr('class', 'header').attr('transform', `translate(${margin.left}, ${margin.top})`)

  // Chart
  svg
    .append('g')
    .attr('class', 'chart')
    .attr('transform', `translate(${margin.left}, ${headerHeight + margin.top})`)

  // Legend Group
  header
    .append('g')
    .attr('class', 'legend-group')
    .attr('transform', `translate(${width() - legendWidth + margin.left}, 0)`)
}

const selectSvg = containerSelector => {
  return d3.select(containerSelector)
}

function parentWidth() {
  const parent = document.querySelector('#trajectories-content')

  if (parent === null) {
    return 1360
  }

  return parent.clientWidth
}

export { margin, legenditemHeight, legendWidth, height, width, setUpChart, selectSvg }
